import { create } from "zustand";

interface GlobalChatsStore {
  supervisorUnreadMessage: boolean;
  setSupervisorUnreadMessage: (value: boolean) => void;
}

export const useGlobalChats = create<GlobalChatsStore>((set) => ({
  supervisorUnreadMessage: false,
  setSupervisorUnreadMessage: (value) =>
    set({ supervisorUnreadMessage: value }),
}));
